<template>
  <div class="help-text" itemprop="acceptedAnswer" itemscope="" itemtype="http://schema.org/Answer">
    <span itemprop="text">{{ param.text }}</span>
    <component
      :is="componentTag"
      v-if="param.link"
      v-bind="param.link"
      target="_blank"
      class="text-decoration-underline"
    >
      {{ param.link.title }}
    </component>
  </div>
</template>

<script setup lang="ts">
import {PropType, resolveComponent} from 'vue'
import { PublicHelpItem } from '~~/types/public'

const props = defineProps({
  param: {
    type: Object as PropType<PublicHelpItem>,
    default: () => ({})
  }
})

const componentTag = computed(() => {
  if (props.param?.link.to) {
    return resolveComponent('NuxtLink')
  }
  return 'a'
})
</script>
